import {
  Component,
  OnInit,
  Inject
} from '@angular/core';
import {
  FormArray,
  FormGroup,
  FormControl,
} from '@angular/forms';
import {
  mergeMap,
} from 'rxjs/operators';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {
  QuizAnswer,
  QuizChoicesProperties,
  QuizInputProperties,
  Course,
  Annotation,
  getDefaultChoicesQuiz,
  getDefaultInputQuiz,
  getDefaultAction,
  Scene,
  QuizType,
  AnnotationType
} from '@shared/models';

@Component({
  selector: 'quiz-settings',
  templateUrl: './quiz-settings.component.html',
  styleUrls: ['./quiz-settings.component.scss']
})
export class QuizSettingsComponent implements OnInit {
  quizAnswer: QuizAnswer;
  quizSettingsForm: FormGroup;
  quiz: QuizChoicesProperties | QuizInputProperties;
  scene: Scene;
  course: Course;
  annotation: Annotation;
  constructor(
    public _dialogRef: MatDialogRef<QuizSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { annotation: Annotation, scene: Scene, course: Course }
  ) {
    // Init form group with annotation properties
    this.quizSettingsForm = new FormGroup(
      {
        question: new FormControl(''),
        restart_enabled: new FormControl(false),
        answers: new FormControl(''),
        quiz_type: new FormControl(''),
        accepted_answers: new FormControl(''),
        continue_label: new FormControl('> Continue'),
        validate_label: new FormControl('Validate'),
        restart_label: new FormControl('Restart'),
        is_answered_individually: new FormControl(false),
      }
    );
  }

  ngOnInit(): void {
    this.course = this.data.course;
    this.scene = this.data.scene;
    this.annotation = this.data.annotation;
    this.quiz = JSON.parse(JSON.stringify(this.data.annotation.properties.quiz));
    this.quizSettingsForm.reset(this.quiz, { emitEvent: false });
  }

  addAnswer(): void {
    let id;
    if ((this.quiz as QuizChoicesProperties).answers.length === 0) {
      id = 1;
    } else {
      id = <number>(this.quiz as QuizChoicesProperties).answers[(this.quiz as QuizChoicesProperties).answers.length - 1].id + 1;
    }
    (this.quiz as QuizChoicesProperties).answers.push(new QuizAnswer(id, 'Choice ' + id, null, getDefaultAction()));
  }

  answerChange(event: any): void {
    const answer = event;
    const index = (this.quiz as QuizChoicesProperties).answers.findIndex(
      s => s.id === answer.id);
      (this.quiz as QuizChoicesProperties).answers[index] = answer;
  }

  answerDelete(event: any): void {
    const answerId = event;
    const index = (this.quiz as QuizChoicesProperties).answers.findIndex(
      s => s.id === answerId);
      (this.quiz as QuizChoicesProperties).answers.splice(index, 1);
  }

  saveAndClose(): void {
    this.quiz = {...this.quiz, ...this.quizSettingsForm.value};
    this._dialogRef.close(this.quiz);
  }
  
  updateQuizType(event: any): void{
    if (event.value === QuizType.choices){
      this.quiz = getDefaultChoicesQuiz();
    }
    if(event.value === QuizType.input){
      this.quiz = getDefaultInputQuiz();
    }
    this.quizSettingsForm.reset(this.quiz, { emitEvent: false });
  }

  updateOutput(output: string, event: any): void{
    if (output === 'success_output'){
      (this.quiz as QuizInputProperties).success_output = event;
    }
    if (output === 'failure_output'){
      (this.quiz as QuizInputProperties).failure_output = event;
    }
  }
}
